import React, { useState, useEffect } from "react";

import {
  RideGlArrowBack,
  RideGrid,
  RideIconButton,
} from "@rimac-seguros/ride-system-components";
import { useSelector } from "react-redux";

import history from "@/utils/history";

import "./styles.scss";

export const NewStepper = ({ currentStep, routeMain, itemsStepsRoutes }) => {
  const [step, setStep] = useState(1);
  const { userData } = useSelector((state) => state.vida);
  const { indPrevPageApp } = userData;

  useEffect(() => {
    if (currentStep) {
      setStep(currentStep);
    }
  }, [currentStep]);

  const handleClickBack = () => {
    setStep(step - 1);
    history.push(itemsStepsRoutes[step - 2] ?? routeMain);
  };

  useEffect(() => {
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [itemsStepsRoutes, routeMain, step]);

  const handlePopState = () => {
    history.push(itemsStepsRoutes[step - 2] ?? routeMain);
  };

  const percentComplete = `${(step / itemsStepsRoutes.length) * 100}`;

  return (
    <>
      <div className="new-stepper_mob">
        <RideGrid className="new-stepper_mob--grid">
          <div className="new-stepper_mob--content">
            <RideIconButton
              glyph={<RideGlArrowBack />}
              variant="unfill"
              size="large"
              onClick={handleClickBack}
            />
            <div className="new-stepper_mob--content-bar">
              <div
                className="new-stepper_mob--content-bar-fill"
                style={{ width: `${percentComplete}%` }}
              />
            </div>
            <span className="ride-sys-text-label-large-semibold min-w-max">
              Paso {step} de {itemsStepsRoutes.length}
            </span>
          </div>
        </RideGrid>
      </div>

      <div
        className={`new-stepper_desktop--bar ${
          indPrevPageApp ? "relative" : "sticky top-14"
        }`}
      >
        <div
          className="new-stepper_desktop--bar-fill"
          style={{ width: `${percentComplete}%` }}
        ></div>
      </div>

      <RideGrid className="hidden lg:grid">
        <div className="new-stepper_desktop--content">
          <span>
            Paso {step} de {itemsStepsRoutes.length}
          </span>
        </div>
      </RideGrid>
    </>
  );
};
